import type { ITemplatePageConfig } from '~/types/template'

import { page4CommonBlocks, page4PickerCommonPlaceholders } from './common'

import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import FrameBlock from '~/components/DynamicScreen/Blocks/Frame'
import FrameBackgroundBlock from '~/components/DynamicScreen/Blocks/FrameBackground'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'

//PAGE
export const pickerPaywallPage4a: ITemplatePageConfig = {
  backgroundImage: 'background_img_4',
  blocks: page4CommonBlocks,
  className: 'page-4a',
  filters: ['eligible', 'not_eligible'],
  name: '4a. Paywall',
  placeholders: [
    ...page4PickerCommonPlaceholders,
    {
      category: 'picker',
      component: TextBlock,
      defaultValue: {
        color: '#0073FF',
      },
      filters: ['eligible'],
      iapKey: 'iap_1',
      placeholderKey: 'days_free_txt_4a',
      previewProperties: {
        text: '3 - days free trial',
      },
      type: ['translation', 'color'],
    },
    {
      category: 'picker',
      className: 'picker-shape inactive',
      component: FrameBackgroundBlock,
      defaultValue: { color: '#dbdbdb' },
      placeholderKey: 'action_variant_4a',
      type: ['color'],
    },
    {
      category: 'picker',
      className: 'picker-shape',
      component: FrameBlock,
      defaultValue: { color: '#0073FF' },
      placeholderKey: 'picker_shape_4a_border',
      type: 'color',
    },
    {
      category: 'picker',
      className: 'picker-shape',
      component: FrameBackgroundBlock,
      defaultValue: { color: '#ffffff' },
      placeholderKey: 'picker_shape_4a_background',
      type: 'color',
    },
    {
      category: 'button',
      className: 'button-text',
      component: TextBlock,
      defaultValue: {
        color: '#FFFFFF',
      },
      placeholderKey: 'buy_txt_4a',
      previewProperties: {
        text: 'Continue',
      },
      type: ['translation', 'color'],
    },
    {
      category: 'button',
      component: ButtonBlock,
      defaultValue: {
        color: '#0073FF',
      },
      placeholderKey: 'action_buy_cta_4a',
      type: ['color'],
    },
  ],
}
